// tabIds serve as unique identifiers for 'openProjectLists' in
// redux state. However, modals that are not associated with any
// open tabs (such as AdrSearch and ReportSelection) do not have
// tabIds - but still carry a need to store data in openProjectLists.
// Therefore these constants are created to serve as mock tabIds.
// As a side benefit, when re-opening modals, these constants will
// allow easy lookup of existing lists that were used in previous
// modal instances.

export const modalTabIds = {
  ADR_SEARCH: 10001, // Only used when accessed via mainNav (not from AdrList)
  REPORT_SELECTION: 10002,
  PROJ_ASSIGNMENT: 10003,
  EDIT_USER: 10004,
  EDIT_USER_DETAILS: 10005,
  VALIDATE_DATA: 10006,
};
